// REDUX
import { createSlice } from "@reduxjs/toolkit";

// MISC
import { IFiltersInitialState } from "models/interfaces";

const initialState: IFiltersInitialState = {
  filters: {
    searchBarValue: "",
    lockerSelectValue: "",
    reportTypeValue: "",
    statusTypeValue: "",
    startDate: null,
    endDate: null,
    page: 0
  },
  isLoading: false,
  errorMessage: "",
};

export const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    handleSearchBarValueChange: (state, action) => {
      state.filters.searchBarValue = action.payload;
    },
    handleLockerSelectValueChange: (state, action) => {
      state.filters.lockerSelectValue = action.payload;
    },
    handleReportTypeValueChange: (state, action) => {
      state.filters.reportTypeValue = action.payload;
    },
    handleStatusTypeValueChange: (state, action) => {
      state.filters.statusTypeValue = action.payload;
    },
    handleStartDateChange: (state, action) => {
      state.filters.startDate = action.payload;
    },
    handleEndDateChange: (state, action) => {
      state.filters.endDate = action.payload;
    },
    handlePageChange: (state, action) => {
      state.filters.page = action.payload;
    },
    handleResetFiltersState: (state) => {
      state.filters = {
        searchBarValue: "",
        lockerSelectValue: "",
        reportTypeValue: "",
        statusTypeValue: "",
        startDate: null,
        endDate: null,
        page: 0
      }
    }
  },
  extraReducers: {},
});

//eslint-disable-next-line
export const {
  handleEndDateChange,
  handleLockerSelectValueChange,
  handleReportTypeValueChange,
  handleSearchBarValueChange,
  handleStartDateChange,
  handleStatusTypeValueChange,
  handleResetFiltersState,
  handlePageChange
} = filtersSlice.actions;

export const filters = (state) => state.filters.filters;

export default filtersSlice.reducer;
